/* eslint-disable security/detect-non-literal-fs-filename */
/* eslint-disable react/jsx-key */
/* eslint-disable max-len */
import React from 'react'
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel} from 'react-responsive-carousel';
import { CDN } from '../../../constants';

const Banner = ({bannerList,setBannerList}) => {
    const bannerlink = (item) => {
        window.open(item.link.includes('http')?item.link:`https://${item.link}`, '_blank').focus();
    }
    return (
        <div className="sm:px-5 px-3 sm:py-5 py-3 mt-[13px] bg-[#F5F5FA] rounded-lg">
            <Carousel autoPlay interval={3000} infiniteLoop={true} axis='horizontal' showArrows={false} showStatus={false} showThumbs={false} >
                {bannerList.length > 0 && bannerList.map((item) => (
                    <div onClick={() => bannerlink(item)}>
                        <img 
                            src={`${CDN}/${item.desktop_url}`} 
                            alt="icon" 
                            className="cursor-pointer"
                        />
                    </div>
                ))}
            </Carousel>          
        </div>
    )
}

export default Banner
